<template>
    <div>
        <div class="container">
            <div class="handle-box">
                <el-select v-model="location_type" class="handle-select mr10" @change="selectHandle">
                    <el-option
                      v-for="(child, index) in location_types"
                      :key="index"
                      :label="child.name" :value="child.id"></el-option>
                </el-select>
                <el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-add"
                    @click="addEdit"
                >新增</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                v-loading="loading"
            >
                <el-table-column label="序号" align="center" width="50">
                    <template slot-scope="scope">
                        <span>{{scope.$index+1}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="方名" align="center"></el-table-column>
                <el-table-column label="内容" align="center">
                    <template slot-scope="scope">
                        {{stringToJson(scope.row.content)}}
                    </template>
                </el-table-column>
                <el-table-column prop="category_name" label="类型" align="center"></el-table-column>
                <el-table-column label="操作" width="200" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.row)"
                        >修改</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            @click="handleDelete(scope.row)"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination" v-if="totalPages > 1">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :current-page="currentPage"
                    :page-size="page_size"
                    :page-count="totalPages"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <el-dialog :visible.sync="editVisible" width="80%" :close-on-click-modal="false">
            <el-form ref="ruleForm" :model="form" :rules="rules" label-width="120px">
                <el-form-item label="方名：" prop="name">
                    <el-input
                     v-model="form.name" @input="onInput()"></el-input>
                </el-form-item>
                <el-form-item label="分类：">
                    <el-select v-model="category_id" class="handle-select">
                        <el-option
                        v-for="(child, index) in categories"
                        :key="index"
                        :label="child.name" :value="child.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="内容：">
                    <el-input
                     placeholder="请输入药名、首字母"
                     v-model="medicine" @input="handleSearchMedicine"></el-input>
                     <ul class="medicines-ul clearfix">
                         <li 
                         v-for="(child, index) in medicines" 
                         :key="index"
                         class="medicines-li fl"
                         @click="handleSelectMedicine(child)"
                         >{{child.name}}</li>
                     </ul>
                     <ul class="select-medicines-ul clearfix">
                         <li 
                         v-for="(child, index) in select_medicines" 
                         :key="index"
                         class="select-medicines-li fl"
                         >
                            <el-button
                                type="danger"
                                circle
                                icon="el-icon-lx-delete"
                                class="delete-medicine"
                                @click="deleteSelectMedicine(child)"
                            ></el-button>
                            <p class="medicine-name">{{child.name}}</p>
                            <el-input v-model="child.quantity" class="medicine-input" @input="onInput()"></el-input>
                            <span class="medicine-unit">{{child.unit}}</span>
                         </li>
                     </ul>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer self-dialog-footer">
                <el-button type="primary" @click="saveEdit('ruleForm')">提 交</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import {_} from 'vue-underscore';
import http from '../../../api/dorisApiConfig'
export default {
    name: 'prescriptionlist',
    data() {
        return {
            location_types: [{"name": "全部", "id": ''}],
            location_type: '',
            provider_type: 1,
            tableData: [],
            currentPage: 1,
            totalPages: 1,
            page_size: 10,
            pageTotal: 10,
            page_index: 10,
            loading: false,
            imageUrl: '',
            multipleSelection: [],
            editVisible: false,
            is_add: false,
            uploading: false,
            form: {},
            rules: {
                name: [{ required: true, message: "请填写方名", trigger: "blur" }],
                content: [{ required: true, message: "请填写内容", trigger: "blur" }]
            },
            categories: [],
            category_id: '',
            medicines: [],
            medicine: '',
            select_medicines: []
        };
    },
    created() {
        let that = this;
        http.get("admin/categories",{params: {'page': 1, 'page_size': 30}}).then(function(res) {
            that.categories = res.data.data.categories;
            that.location_types = that.location_types.concat(that.categories);
        });
        this.getData();
    },
    methods: {
        formatDate(time){
            return new Date(time*1000).Format('YYYY-MM-DD hh:mm:ss');
        },
        stringToJson(json){
            if(json){
                json = JSON.parse(json);
                let str = '';
                for(let i = 0; i < json.length; i++){
                    if(i == 0){
                        str = json[i]['name'] + json[i]['quantity'] + json[i]['unit'];
                    }else{
                        str += '，' + json[i]['name'] + json[i]['quantity'] + json[i]['unit'];
                    }
                }
                return str;
            }else{
                return '';
            }
        },
        handleSearchMedicine(){
            let that = this;
            let params = {
                page: 1,
                page_size: 10
            }
            if(that.medicine){
                params['keyword'] = that.medicine;
                http.get("admin/sh_medicines",{params: params}).then(function(res) {
                    that.medicines = res.data.data.medicines;
                });
            }else{
                that.medicines = [];
            }
            that.$forceUpdate();
        },
        handleSelectMedicine(row){
            let that = this;
            let item = _.filter(that.select_medicines, function(selector){ return selector.name == row.name; });
            if(item.length > 0){
                that.$message.error(`药品已添加`);
            }else{
                that.select_medicines.push({"name": row.name, "unit": row.unit, "quantity": ''});
            }
        },
        deleteSelectMedicine(row){
            let that = this;
            that.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
            .then(() => {
                let index = _.findIndex(that.select_medicines, function(selector){ return selector.name == row.name; });
                that.select_medicines.splice(index, 1);
            })
            .catch(() => {});
        },
        getData() {
            let that = this;
            that.loading = true;
            let params = {
                page: that.currentPage,
                page_size: that.page_size
            }
            if(that.location_type){
                params["category_id"] = that.location_type;
            }
            http.get("admin/common_prescriptions",{params: params}).then(function(res) {
                that.tableData = res.data.data.prescriptions;
                that.currentPage = res.data.data.current_page;
                that.totalPages = res.data.data.total_pages;
                that.loading = false;
            });
        },
        //选择
        selectHandle(){
            this.currentPage = 1;
            this.getData();
        },
        // 触发搜索按钮
        handleSearch() {
            this.currentPage = 1;
            this.getData();
        },
        // 删除操作
        handleDelete(row) {
            let that = this;
            // 二次确认删除
            that.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
            .then(() => {
                let params = {
                    prescription_id: row.id
                }
                http.delete("admin/common_prescription", {params: params}).then(function(res) {
                    // console.log(res);
                    if (res.data.status_code == 200) {
                        that.$message.success('删除成功');
                        that.getData();
                    }else{
                        that.$message.error(res.data.msg);
                    }
                });
            })
            .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        onInput(){
            this.$forceUpdate();
        },
        // 编辑操作
        handleEdit(row) {
            this.form = {
                prescription_id: row.id,
                name: row.name
            };
            this.medicines = [];
            this.category_id = row.category_id;
            this.select_medicines = JSON.parse(row.content);
            this.medicine = '';
            this.is_add = false;
            this.editVisible = true;
        },
        //新增操作
        addEdit(){
            this.form = {
                name: ''
            }
            this.medicines = [];
            this.select_medicines = [];
            if(this.location_type == ''){
                this.category_id = 1;
            }else{
                this.category_id = this.location_type;
            }
            this.medicine = '';
            this.is_add = true;
            this.editVisible = true;
        },
        // 保存编辑
        saveEdit(formName) {
            let that = this;
            if(that.select_medicines.length > 0){
                that.$refs[formName].validate(valid => {
                    if (valid) {
                        let params = {
                            category_id: that.category_id,
                            name: that.form.name,
                            content: JSON.stringify(that.select_medicines)
                        };
                        console.log(typeof(JSON.stringify(that.select_medicines)))
                        if(that.is_add){
                            http.post("admin/common_prescription", params).then(function(res) {
                                // console.log(res);
                                if (res.data.status_code == 200) {
                                    that.$message.success(`新增成功`);
                                    that.getData();
                                }else{
                                    that.$message.error(res.data.msg);
                                }
                            });
                        }else{
                            params['prescription_id'] = that.form.prescription_id;
                            http.put("admin/common_prescription", params).then(function(res) {
                                // console.log(res);
                                if (res.data.status_code == 200) {
                                    that.$message.success(`修改成功`);
                                    that.getData();
                                }else{
                                    that.$message.error(res.data.msg);
                                }
                            });
                        }
                        that.editVisible = false;
                    } else {
                        console.log("error submit!!");
                        return false;
                    }
                });
            }else{
                 that.$message.error(`请添加内容`);
            }
        },
        // 分页导航
        handlePageChange(val) {
            this.currentPage = val;
            this.getData();
        }
    }
};
</script>

<style lang="scss" type="text/css" scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 180px;
}
.self-dialog-footer{
    display: block;
    text-align: center;
}
.avatar {
    height: 178px;
    display: block;
    max-width: 100%;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.clearfix:after{content:"";display:block;height:0;clear:both;visibility:hidden;}
.fl{float:left;display:inline;}
.fr{float:right;display:inline;}
.medicines-ul{
    margin-top: 5px;
}
.medicines-ul .li,
.select-medicines-ul li{
    list-style-type: none;
}
.medicines-li{
    margin-right: 5px;
    margin-bottom: 5px;
    display: block;
    max-width: 100%;
    height: 30px;
    line-height: 20px;
    box-sizing: border-box;
    color: #333;
    text-align: center;
    font-size: 14px;
    padding: 5px;
    border: 1px solid #eee;
    border-radius: 6px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    cursor: pointer;
}
.select-medicines-ul{
    width: 100%;
    min-height: 200px;
}
.select-medicines-li{
    margin-top: 10px;
    width: 33.333333%;
    box-sizing: border-box;
    padding-left: 25px;
    padding-right: 100px;
    position: relative;
}
.delete-medicine{
    width: 20px;
    height: 20px;
    padding: 3px;
    margin: auto;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
}
.medicine-name{
    display: block;
    width: 100%;
    height: 32px;
    line-height: 32px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.medicine-input{
    width: 50px;
    height: 32px;
    line-height: 32px;
    display: block;
    text-align: center;
    position: absolute;
    right: 50px;
    top: 0;
}
.medicine-input .el-input__inner{
    text-align: center;
}
.medicine-unit{
    display: block;
    height: 32px;
    line-height: 32px;
    position: absolute;
    right: 30px;
    top: 0;
}
</style>
